<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="d-flex flex-fill flex-row">
            <div class="d-flex flex-column"  >
                <div class="d-flex flex-row m-1">
                    <div class="ms-1">
                        <div class="dx-field-label date-search-label" style="overflow: unset; text-overflow: unset">Start</div>
                    </div>
                    <div class="ms-1 date-search-box">
                        <dx-date-box [(value)]="startDate"></dx-date-box>
                    </div>
                    <button class="btn btn-success" style="min-width: 70px" (click)="getData()" [disabled]="!startDate || !endDate">Search</button>
                </div>
                <div class="d-flex flex-row m-1">
                    <div class="ms-1">
                        <div class="dx-field-label date-search-label" style="overflow: unset; text-overflow: unset">End</div>
                    </div>
                    <div class="ms-1 date-search-box">
                        <dx-date-box [(value)]="endDate"></dx-date-box>
                    </div>
                    <button class="btn btn-secondary" style="min-width: 70px" (click)="resetSearch()">Reset</button>
                </div>
            </div>
            <div class="d-flex flex-fill flex-row">
                <div class="ms-4" style="max-width: 200px">
                    <div class="dx-field-label" style="overflow: unset; text-overflow: unset">Include NonTracked Parts</div>
                </div>
                <div class="ms-1 check-box-style" style="max-width: 60px">
                    <dx-check-box [(value)]="includeNonTracked"></dx-check-box>
                </div>
            </div>
        </div>
    </div>
    <div class="m-2 grid-fill" *ngIf="partInfos">
        <dx-data-grid
            #dataGrid
            keyExpr="partId"
            [dataSource]="partInfos"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="partNumber" width="210"></dxi-column>
            <dxi-column dataField="description" width="200"></dxi-column>
            <dxi-column dataField="trackInventory" width="100"></dxi-column>
            <dxi-column dataField="total" width="100"></dxi-column>
            <dxi-column dataField="inStock" width="100"></dxi-column>
            <dxi-column dataField="reOrderMinimum" width="100"></dxi-column>
            <dxi-column dataField="category" width="100"></dxi-column>
            <dxi-column dataField="countAsWIP" caption="Allocated" width="100"></dxi-column>
            <dxi-column dataField="used" width="100"></dxi-column>
            <dxi-column dataField="last3MonthTotal" width="100"></dxi-column>
            <dxi-column dataField="last3to6MonthTotal" width="100"></dxi-column>
            <dxi-column dataField="last6to12MonthTotal" width="100"></dxi-column>
            <dxi-column dataField="greaterThan12MonthTotal" width="100"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export *ngIf="!showAsDialog" [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="!showAsDialog" type="localStorage" storageKey="inventory-usage-grid"></dxo-state-storing>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="partInfos" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
